<pt-sign-header
  [logo]='logo'
  [subtitle]='subtitle'
  [title]='title'>
</pt-sign-header>


<form (keydown.enter)='(formGroup.valid && !loading) ? signIn() : null' [formGroup]='formGroup'
      class='mb-4'>

  <div *ngIf='!domain && domainLabel' class='w-100 mb-3'>
    <label class="form-label" for='domain'>{{ domainLabel }}</label>
    <input autocomplete='off'
           class='form-control form-control-sm'
           formControlName='domain'
           id='domain'
           type='text'>
  </div>

  <div *ngIf='usernameLabel' class='w-100 mb-3'>
    <label class="form-label" for='username'>{{ usernameLabel }}</label>
    <input aria-describedby='usernameHelp'
           autocomplete='off'
           class='form-control form-control-sm'
           formControlName='username'
           data-testid="username"
           id='username'
           type='text'>
  </div>

  <pt-input-password
    *ngIf='passwordLabel'
    [controlName]='"password"'
    [generateEnabled]='false'
    [label]='passwordLabel'
    [showRequiredSign]='false'
    [useComponentStyle]='false'
    [validators]='[]'
    [passwordParamsResponse]="passwordParamsResponse"
    formControlName='password'
  ></pt-input-password>

  <div *ngIf='otpRequired' class='w-100 mb-3 mt-3'>
    <label class="form-label" for='otpCode'>{{ otpLabel }}</label>
    <input aria-describedby='otpCodeHelp'
           autocomplete='off'
           class='form-control form-control-sm'
           formControlName='otpCode'
           id='otpCode'
           type='text'>
  </div>

</form>

<pt-sign-actions
  (onCancel)="cancel.emit()"
  (onConfirm)='signIn()'
  (onForgotPassword)='forgotPassword()'
  [cancelLabel]="cancelLabel"
  [confirmLabel]='signInButtonLabel'
  [enabledConfirm]='formGroup.valid && !loading'
  [forgotLabel]='forgotPasswordLabel'
  [showCancel]='otpRequired'
  [showConfirm]='true'
  [showForgotPassword]='!hasMicrosoftAuth'>
</pt-sign-actions>

<div *ngIf="hasMicrosoftAuth">
  <div class="d-flex align-items-center my-4">
    <hr class="flex-grow-1">
    <span class="px-3 text-muted small">or</span>
    <hr class="flex-grow-1">
  </div>

  <button class="btn btn-outline-secondary w-100" (click)="microsoftLogin.emit()">
    <img src="/assets/images/microsoft.svg" alt="" width="20" />
    Microsoft
  </button>
</div>

<div class="mt-2">
  <pt-warning *ngIf="warningMessage | async" [message]="warningMessage | async" [allowHtml]="true"></pt-warning>
  <pt-warning *ngIf="loginFailedMessage | async" [message]="loginFailedMessage | async"></pt-warning>
</div>
